module.exports = __webpack_public_path__ + "static/media/bell-cowbell3.41a24ec6.aac";